import Vue from 'vue'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import store from '../store'

Vue.use(VueAxios, Axios)

/* 請求超時時間 */
Vue.axios.defaults.timeout = 10000
/* 後台 Api 路徑 */
// Vue.axios.defaults.baseURL = location.protocol + '//' + location.host + '/api/'
Vue.axios.defaults.baseURL = location.protocol + '//' + 'modcms.chjhs.tp.edu.tw' + '/api/'
if (process.env.NODE_ENV === 'development') {
  // Vue.axios.defaults.baseURL = 'http://127.0.0.1/cms/public/api/'
  // Vue.axios.defaults.baseURL = 'http://127.0.0.1/chjhs_cms_new2020/public/api/'
  Vue.axios.defaults.baseURL = 'http://localhost:8092/api/'
  // Vue.axios.defaults.baseURL = 'http://demo.cms4m.com/api/'
}

// 請求攔截
Vue.axios.interceptors.request.use(
  config => {
    // 轉換查詢參數
    config.transformRequest = [function (data) {
      data = Qs.stringify(data)
      return data
    }]
    // 如果是登入狀態，設定 Auth Token
    if (store.state.token) {
      config.headers.Authorization = store.state.token
    }
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers.withCredentials = true
    return config
  },
  error => {
    return Promise.reject(error)
  })

// 回應攔截及錯誤處理
Vue.axios.interceptors.response.use(
  response => {
    let token = response.headers.authorization
    if (token) {
      // 如果 header 中存在 token，那觸發 refreshToken 方法，替換原本的 token
      store.dispatch('refreshToken', token)
    }
    return response
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 401:
          if (err.response.data.msg) {
            alert(err.response.data.msg)
          } else {
            alert('帳號已登出！')
          }
          this.$store.dispatch('clearLoginInfo')
          break
        // case 404:
        //   console.log('找不到該頁面')
        //   break
        // case 500:
        //   console.log('伺服器出錯')
        //   break
        // case 503:
        //   console.log('服務失效')
        //   break
        // default:
        //   console.log(`連接錯誤${err.response.status}`)
      }
    }
    return Promise.resolve(err.response)
  }
)
